var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 16,
    viewBox: "0 0 53 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4069 15.8173L21.0423 0.31665H25.2575L22.6202 15.8173H18.4069Z",
    fill: "#0E4595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8492 0.651022C37.0142 0.336992 35.7056 0 34.0713 0C29.9061 0 26.9722 2.10232 26.9472 5.11538C26.9237 7.34264 29.0418 8.58514 30.6407 9.32659C32.2815 10.0865 32.8331 10.571 32.8252 11.2493C32.8147 12.2884 31.5149 12.7629 30.3032 12.7629C28.6162 12.7629 27.7199 12.528 26.3355 11.9494L25.7922 11.703L25.2007 15.173C26.1852 15.6058 28.0058 15.9805 29.8962 16C34.3273 16 37.2038 13.9217 37.2365 10.7041C37.2522 8.94074 36.1293 7.59895 33.6973 6.49264C32.2239 5.77558 31.3216 5.2971 31.3312 4.57101C31.3312 3.92672 32.0949 3.23777 33.7453 3.23777C35.1236 3.21631 36.1222 3.51759 36.9002 3.83162L37.2779 4.01049L37.8492 0.651022Z",
    fill: "#0E4595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6964 0.316528H45.4393C44.4303 0.316528 43.6751 0.592551 43.232 1.60194L36.9718 15.8071H41.3982C41.3982 15.8071 42.1218 13.8972 42.2855 13.4777C42.7692 13.4777 47.0693 13.4844 47.684 13.4844C47.8101 14.0271 48.1969 15.8071 48.1969 15.8071H52.1083L48.6964 0.316528ZM43.5286 10.3256C43.8773 9.4325 45.2081 5.9925 45.2081 5.9925C45.1833 6.03375 45.5542 5.09507 45.7669 4.51309L46.0519 5.8495C46.0519 5.8495 46.859 9.54953 47.0277 10.3253H43.5286V10.3256Z",
    fill: "#0E4595"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.053849 0.31665L0 0.639094C1.66632 1.04339 3.15459 1.62855 4.45759 2.35648L8.19785 15.7924L12.6578 15.7875L19.294 0.31665H14.8285L10.7018 10.8869L10.2622 8.7387C10.2416 8.67233 10.2192 8.60584 10.1963 8.5392L8.76165 1.62529C8.50656 0.643772 7.76653 0.350856 6.85101 0.31665H0.053849Z",
    fill: "#0E4595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0b6c26004c11b53b304df7ae81e1e9fb.svg";
export { ForwardRef as ReactComponent };